import { AssetType } from '../../../api/models/Shared.types';
import { DetailTranslationKeys, ErrorTranslationKeys } from '../../../api/models/TranslationKeys';
import { BookmarkUtility } from '../../utility/BookmarkUtility';
import { Log, Router } from '@lightningjs/sdk';
import { DetailAction } from './DetailAction';
import { VodStreamInfo } from '../../player/streamInfo/VodStreamInfo';
import { StartPositionType } from '../../player/streamInfo/StreamInfo';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { Backend } from '../../../api/Backend';
import { VodAsset } from '../vod/VodAsset';
import { VodStreamRights } from '../vod/VodStreamRights';
import { OptionData } from '../../../components/option/OptionData';
import { IBookmarkElementV1 } from '../../../api/models/AndromeTV.types';

export const WatchActionTypes = {
  WATCH_FROM_BEGINNING: 'WATCH_FROM_BEGINNING',
  CONTINUE_WATCHING: 'CONTINUE_WATCHING',
  WATCH_LIVE: 'WATCH_LIVE',
};

export class VodWatchAction extends DetailAction {
  private streamRights: VodStreamRights;
  private vod: VodAsset;
  constructor(backend: Backend, vod: VodAsset, streamRights: VodStreamRights) {
    super(backend);
    this.streamRights = streamRights;
    this.vod = vod;
  }

  override doAction() {
    if (!this._backend.isAuthorized() && !this.streamRights.hasWatchableOttFVOD()) {
      //TODO show login menu
      return;
    }

    this.showVodWatchOptions();
  }

  showVodWatchOptions() {
    const bookmarkProm = this._backend.cachedBookmarkApi.bookmarkShortCache(
      this._backend,
      {
        type: AssetType.VOD,
        id: this.vod.assetId,
      },
      false //TODO adult
    );

    this._backend.cachedQuoteApi.bypassCache(true);
    const quoteProm = this._backend.cachedQuoteApi.list(this._backend, this._backend.deviceProfile?.profile.catalog);

    Promise.all([bookmarkProm, quoteProm])
      .then(([bookmark, quotes]) => {
        this.streamRights.calculateStreamRightsForNewQuotes(quotes);
        if (bookmark && BookmarkUtility.isPartial(this._backend, bookmark)) {
          this.showContinueWatchingDialog(bookmark);
        } else {
          this.startWatch({ value: WatchActionTypes.WATCH_FROM_BEGINNING, options: [] }, bookmark);
        }
      })
      .catch(() => {
        this.owner?.fireAncestors(
          '$showMessage',
          this._backend.translations.forKey(ErrorTranslationKeys.error_general)
        );
      });
  }

  showContinueWatchingDialog(bookmark: IBookmarkElementV1) {
    this.owner?.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        backend: this._backend,
        name: 'Select watch option',
        title: this.vod.text.title,
        options: [
          {
            text: this._backend.translations.forKey(DetailTranslationKeys.detail_watch_from_bookmark),
            value: WatchActionTypes.CONTINUE_WATCHING,
          },
          {
            text: this._backend.translations.forKey(DetailTranslationKeys.detail_watch_from_beginning),
            value: WatchActionTypes.WATCH_FROM_BEGINNING,
          },
        ],
        onSuccess: (val: OptionData) => {
          this.hideOptions();
          this.startWatch(val, bookmark);
        },
        onCancelled: this.hideOptions.bind(this),
      },
    });
  }

  startWatch(option: OptionData, bookmark: IBookmarkElementV1 | undefined) {
    const type = option.value;
    Log.info('Starting watch', type);
    let streamInfo;
    const ottStream = this.streamRights.getWatchableOttStream();
    if (!ottStream) {
      Log.error('No watchable OttStream found', this.vod);
      this.owner?.fireAncestors(
        '$showMessage',
        this._backend.translations.forKey(ErrorTranslationKeys.error_streaming)
      );
      return;
    }
    switch (type) {
      case WatchActionTypes.WATCH_FROM_BEGINNING:
        streamInfo = new VodStreamInfo(this.vod, ottStream, bookmark, StartPositionType.START);
        Router.navigate('play', { streamInfo });
        return;
      case WatchActionTypes.CONTINUE_WATCHING:
        streamInfo = new VodStreamInfo(this.vod, ottStream, bookmark, StartPositionType.BOOKMARK);
        Router.navigate('play', { streamInfo });
        return;
    }
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }
}
